import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { JsonPipe, NgForOf, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { ScrollTopModule } from 'primeng/scrolltop';

@Component({
  selector: 'app-call-transcription-dialog',
  standalone: true,
  imports: [
    AvatarModule,
    NgIf,
    TranslateModule,
    DividerModule,
    DialogModule,
    JsonPipe,
    NgForOf,
    ScrollTopModule,
  ],
  templateUrl: './call-transcription-dialog.component.html',
  styleUrls: ['./call-transcription-dialog.component.scss'],
})
export class CallTranscriptionDialogComponent {
  @Input() transcription: { message: string; speaker: string }[] = [];
  @Input() customerName = '';
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  onHide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
